// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalculatorV1-module_calculatorFrame__At3wk {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    padding-bottom: var(--keyboardHeight);
}
.CalculatorV1-module_calculatorFrameTop__QvyLA {
    display: flex;
    align-items: center;
    flex-grow: 1;
    justify-content: center;
    padding: 24px;
}
.CalculatorV1-module_calculatorAmountContainer__WeHLH {
    display: flex;
    column-gap: 16px;
}
.CalculatorV1-module_calculatorFrameBottom__aEIf_ {
    margin-top: 24px;
    padding: 24px;
    display: flex;
    border-top: 1px solid var(--grey_16_tr);
    border-bottom: 1px solid var(--grey_16_tr);
    position: relative;
}
.CalculatorV1-module_calculatorButtonStyled__w2ZR3 {
    display: flex;
    justify-content: center;
    padding: 38px 24px;
    width: 100%;
    box-sizing: border-box;
    pointer-events: none;
}
.CalculatorV1-module_calculatorInputWrapper__rGCIK {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: relative;
    padding: 16px 0;
}
.CalculatorV1-module_pricingTabBlock__UhA90 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 16px;
    padding: 8px 16px;
    border-radius: 8px;
    background: var(--grey_8_lc);
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Calculactor/CalculatorV1.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,OAAO;IACP,qCAAqC;AACzC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,uCAAuC;IACvC,0CAA0C;IAC1C,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;AAChC","sourcesContent":[".calculatorFrame {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    flex: 1;\n    padding-bottom: var(--keyboardHeight);\n}\n.calculatorFrameTop {\n    display: flex;\n    align-items: center;\n    flex-grow: 1;\n    justify-content: center;\n    padding: 24px;\n}\n.calculatorAmountContainer {\n    display: flex;\n    column-gap: 16px;\n}\n.calculatorFrameBottom {\n    margin-top: 24px;\n    padding: 24px;\n    display: flex;\n    border-top: 1px solid var(--grey_16_tr);\n    border-bottom: 1px solid var(--grey_16_tr);\n    position: relative;\n}\n.calculatorButtonStyled {\n    display: flex;\n    justify-content: center;\n    padding: 38px 24px;\n    width: 100%;\n    box-sizing: border-box;\n    pointer-events: none;\n}\n.calculatorInputWrapper {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    position: relative;\n    padding: 16px 0;\n}\n.pricingTabBlock {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    column-gap: 16px;\n    padding: 8px 16px;\n    border-radius: 8px;\n    background: var(--grey_8_lc);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calculatorFrame": `CalculatorV1-module_calculatorFrame__At3wk`,
	"calculatorFrameTop": `CalculatorV1-module_calculatorFrameTop__QvyLA`,
	"calculatorAmountContainer": `CalculatorV1-module_calculatorAmountContainer__WeHLH`,
	"calculatorFrameBottom": `CalculatorV1-module_calculatorFrameBottom__aEIf_`,
	"calculatorButtonStyled": `CalculatorV1-module_calculatorButtonStyled__w2ZR3`,
	"calculatorInputWrapper": `CalculatorV1-module_calculatorInputWrapper__rGCIK`,
	"pricingTabBlock": `CalculatorV1-module_pricingTabBlock__UhA90`
};
export default ___CSS_LOADER_EXPORT___;
